import React from 'react';
import './Works.css'
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'gatsby';
import FeaturedWorks from './Featured-Works/FeaturedWorks';
const Works = () => {
    return (
        <section>
            <Row>
                <Col md={7}>
                    <div className="section-title">
                        <h1 className=" h2"><span className="text-green">Some of</span> my works</h1>
                        <div className="action text-right">
                            <Link class="details-link" to="/works">
                                <Button variant="outline-success" size="sm">All Works</Button>    
                            </Link>
                        </div>
                    </div>
                </Col>            
            </Row>

            <FeaturedWorks/>
        </section>
    );
};

export default Works;